// EVENTSFLO-FINANCIAL-TAX-RULES-MATRIX-ADMIN-UI-V1
// Shared enum values + human-readable labels mirroring the backend
// `ClientTaxTreatment`, `LineTaxClass`, `VatNumberStatus` and
// `ClientEntityType` enums defined in /app/backend/models.py.
//
// Source of truth = backend. Frontend payloads MUST use the `value`
// strings exactly as listed below — labels are display-only.

export const CLIENT_TAX_TREATMENTS = [
  { value: "domestic_tva", label: "Domestic TVA" },
  { value: "eu_b2b_reverse_charge_services", label: "EU B2B reverse charge services" },
  { value: "non_eu_b2b_services", label: "Non-EU B2B services" },
  { value: "standard_tva", label: "Standard TVA" },
  { value: "manual_review", label: "Manual review" },
];

export const LINE_TAX_CLASSES = [
  { value: "crew_service", label: "Crew service" },
  { value: "crew_allowance", label: "Crew allowance / meal" },
  { value: "crew_chief_service", label: "Crew chief service" },
  { value: "crew_service_supplement", label: "Crew service supplement" },
  { value: "travel_labour_service", label: "Travel labour service" },
  { value: "equipment_rental", label: "Equipment rental" },
  { value: "vehicle_rental", label: "Vehicle rental" },
  { value: "accommodation", label: "Accommodation" },
  { value: "travel_cost", label: "Travel cost" },
  { value: "other_taxable_item", label: "Other taxable item" },
  { value: "manual_review", label: "Manual review" },
];

export const VAT_NUMBER_STATUSES = [
  { value: "not_checked", label: "Not checked" },
  { value: "valid", label: "Valid" },
  { value: "invalid", label: "Invalid" },
  { value: "not_required", label: "Not required" },
  { value: "manual", label: "Manual" },
];

export const CLIENT_ENTITY_TYPES = [
  { value: "business", label: "Business" },
  { value: "individual", label: "Individual" },
  { value: "unknown", label: "Unknown" },
];

// Safe defaults applied when a backend record has the field unset.
// These mirror the safe-default behaviour in
// `tax_rules_service.evaluate_tax_for_financial_line` so the UI never
// silently switches an unmigrated client to a treatment that would
// alter their tax bill.
export const DEFAULT_CLIENT_TAX_TREATMENT = "standard_tva";
export const DEFAULT_LINE_TAX_CLASS = "other_taxable_item";
export const DEFAULT_VAT_NUMBER_STATUS = "not_checked";
export const DEFAULT_CLIENT_ENTITY_TYPE = "unknown";

// Quick lookup helpers.
export const labelFor = (options, value) => {
  if (!value) return "—";
  const found = options.find((o) => o.value === value);
  return found ? found.label : value;
};
